/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerritorySuggestionsRequest
 */
export interface TerritorySuggestionsRequest {
    /**
     * Search query for territory suggestions
     * @type {string}
     * @memberof TerritorySuggestionsRequest
     */
    query: string;
    /**
     * Maximum number of suggestions per territory type
     * @type {number}
     * @memberof TerritorySuggestionsRequest
     */
    maxPerTerritoryType?: number;
}

/**
 * Check if a given object implements the TerritorySuggestionsRequest interface.
 */
export function instanceOfTerritorySuggestionsRequest(value: object): value is TerritorySuggestionsRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function TerritorySuggestionsRequestFromJSON(json: any): TerritorySuggestionsRequest {
    return TerritorySuggestionsRequestFromJSONTyped(json, false);
}

export function TerritorySuggestionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerritorySuggestionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
        'maxPerTerritoryType': json['maxPerTerritoryType'] == null ? undefined : json['maxPerTerritoryType'],
    };
}

export function TerritorySuggestionsRequestToJSON(json: any): TerritorySuggestionsRequest {
    return TerritorySuggestionsRequestToJSONTyped(json, false);
}

export function TerritorySuggestionsRequestToJSONTyped(value?: TerritorySuggestionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'query': value['query'],
        'maxPerTerritoryType': value['maxPerTerritoryType'],
    };
}

